import { mapActions, mapGetters, mapMutations } from 'vuex';

import { email, maxLength, minLength, required } from 'vuelidate/lib/validators';
import validation from '@/mixins/validation';
import IconEye from '@/components/icons/IconEye.vue';
import IconEyeClose from '@/components/icons/IconEyeClose.vue';

export default {
  name: 'Login',
  data() {
    return {
      payload: {
        email: this.$route.query.email ? this.$route.query.email : '',
        password: ''
      },
      validationErrors: {},
      showPassword: false
    };
  },
  mixins: [validation],
  validations() {
    let payload = {
      email:
        this.detectInputType === 'phone'
          ? {
              required,
              minLength: minLength(13)
            }
          : {
              required,
              maxLength: maxLength(120),
              email
            },
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(120)
      }
    };

    return { payload };
  },
  components: {
    IconEyeClose,
    IconEye
    // mainInput
  },
  computed: {
    ...mapGetters({
      loadingSingIn: 'auth/loadingSingIn',
      verifyCodeResponse: 'auth/verifyCodeResponse'
    }),
    detectInputType() {
      let { email } = this.payload;
      let trimmed = email.trim();
      if (trimmed.startsWith('+380')) {
        return 'phone';
      }
      return 'email';
    },
    passwordErrors() {
      return this.computeErrors('payload', 'password', {
        maxLength: { message: 'validation.maxLength', options: { size: 120 } },
        required: 'validation.required',
        minLength: { message: 'validation.minLength', options: { size: 8 } }
      });
    },
    emailOrPhoneErrors() {
      if (this.detectInputType === 'phone') {
        return this.computeErrors('payload', 'email', {
          required: 'validationRequired',
          minLength: { message: 'validationMin', count: 13 }
        });
      }

      return this.computeErrors('payload', 'email', {
        maxLength: { message: 'validation.maxLength', options: { size: 120 } },
        required: 'validation.required',
        email: 'validation.email'
      });
    }
  },
  created() {
    document.getElementById('html').classList.add('hide');
  },
  methods: {
    ...mapMutations({
      modalOpen: 'app/MODAL_OPEN',
      changeLoginPopup: 'popups/CHANGE_LOGIN_POPUP'
    }),
    ...mapActions({
      login: 'auth/GET_TOKEN',
      fetchUser: 'profile/FETCH_USER_DATA',
      getFavorites: 'favorites/GET_FAVORITES_LIST'
    }),
    async onSubmit() {
      this.$v.$touch();
      console.log('++++', this.$v, this.payload);
      if (this.$v.$invalid) {
        return;
      }

      try {
        await this.login(this.payload).then(() => {
          this.fetchUser();
          this.getFavorites();
        });

        this.$toasted.success(this.$t('successLogin'));
        this.changeLoginPopup(false);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'sign_in',
          eventCategory: 'sign_in',
          eventAction: 'sign_in',
          loginMethod: 'email'
        });

        fbq('track', 'sign_in');
      } catch (error) {
        const message = error.data?.message;
        if (message) {
          this.$toasted.error(message);
        }
      }
    },
    onChangeToSMSRegistration() {
      this.changeLoginPopup(false);
      if (this.verifyCodeResponse) {
        this.modalOpen('registration');
      } else {
        this.modalOpen('phoneRegister');
      }
    },
    onChangeToReset() {
      this.changeLoginPopup(false);
      this.modalOpen('reset');
    }
  }
};
